export const categories = [
  { value: "compare", label: "Compare" },
  { value: "process", label: "Process Automation" },
];

export const subCategories = [
  { value: "file2spec", label: "File to Specification" },
  { value: "file2Db", label: "File to Database" },
  { value: "file2File", label: "File to File" },
  { value: "db2Db", label: "Database to Database" },
];

export const processSubCategories = [
  { value: "eventMonitor", label: "Event Monitor" },
  { value: "extractCompressed", label: "Extract Compressed File" },
  { value: "fileManipulation", label: "File Manipulation" },
  { value: "move", label: "File Move, Copy or Delete" },
];

export const documentTypeList = [
  { value: "spec", label: "Specification" },
  { value: "sql", label: "SQL" },
];

export const specFileType = [{ value: "xlsx", label: "xlsx" }];

export const sqlFileType = [
  { value: "sql", label: "SQL" },
  { value: "txt", label: "Text" },
];

export const delimitersList = [
  { value: "comma", label: "Comma" },
  { value: "pipe", label: "Pipe" },
  { value: "tab", label: "Tab" },
];

export const fileManipulationList = [
  { value: "XML", label: "XML" },
  { value: "CSV", label: "CSV" },
  { value: "JSON", label: "JSON" },
];
